export default __webpack_public_path__ + "static/media/polysterikí1.8f83c670.webp";